import React from "react";
import style from "./inmobiliarySections.module.scss";
import { Box, Text, Icon } from "@quintoandar-tokko/jopijs";
import {
  cleanNumberToWhastapp,
  handleMailClick,
  handleMapClick,
  handleWhatsappClick,
  isTrue,
} from "@/components/fichaInfo/utilities/helpers";
import Trans from "@/components/shared/Trans";
import translations from "../../../FichaInfo.trans.json";

function BranchSection({
  company_name,
  branch_name,
  email,
  phone,
  contact_time,
  whatsapp,
  branch_address,
}) {
  return (
    <Box
      __css={{
        display: "flex",
        flexDirection: "column",
        gap: "2px",
      }}
      className={style.colorNeutralGray1}
    >
      {isTrue(company_name) && (
        <Text variant="bodyBold.fontSize14">{company_name}</Text>
      )}
      {isTrue(branch_name) && (
        <Text
          style={{ marginBottom: "5px" }}
          className={style.colorNeutralGray2}
          variant="body.fontSize12"
        >
          {Trans(translations, "Branch")} {branch_name}
        </Text>
      )}
      {isTrue(email) && (
        <Box className={style.alignTextAndICon}>
          <Icon icon="icon-email" />
          <Text
            onClick={() => handleMailClick(email)}
            className={style.textHiden}
            variant="body.fontSize12"
          >
            {email}
          </Text>
        </Box>
      )}
      {isTrue(phone) && <Text variant="body.fontSize12">{phone}</Text>}
      {isTrue(contact_time) && (
        <Text variant="body.fontSize12">{contact_time}</Text>
      )}
      {isTrue(whatsapp) && (
        <Box className={style.alignTextAndICon}>
          <Icon icon="icon-whatsapp" />
          <Text
            onClick={() => handleWhatsappClick(whatsapp)}
            className={style.underline}
            variant="body.fontSize12"
          >
            {cleanNumberToWhastapp(whatsapp)}
          </Text>
        </Box>
      )}
      {isTrue(branch_address) && (
        <Box className={style.alignTextAndICon}>
          <Icon
            style={{ height: "16px" }}
            className={style.centrarIcon}
            icon="icon-ubicacion"
          />
          <Text
            onClick={() => handleMapClick(branch_address)}
            className={style.underline}
            variant="body.fontSize12"
          >
            {branch_address}
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default BranchSection;
